export interface Plan {
  name: string
  price: string
  users: string
  cta: string
  featured?: boolean
  included: string[]
  locked: string[]
}

export const PLANS: Plan[] = [
  {
    name: 'Core',
    price: 'Free',
    users: 'Up to 4 users',
    cta: 'Get started',
    included: ['Lessons Learned', 'Basic dashboard'],
    locked: ['JHA & safety tools', 'Timesheets & reports', 'Push notifications'],
  },
  {
    name: 'Field',
    price: '$49/mo',
    users: 'Up to 15 users',
    cta: 'Get started',
    included: ['Everything in Core', 'JHA & toolbox talks', 'Safety manuals'],
    locked: ['Push notifications', 'Full web dashboard'],
  },
  {
    name: 'Premium',
    price: '$149/mo',
    users: 'Up to 50 users',
    cta: 'Get started',
    featured: true,
    included: [
      'Everything in Field',
      'Push notifications',
      'Timesheets & reports',
      'Certifications',
      'Full web dashboard',
    ],
    locked: [],
  },
  {
    name: 'Enterprise',
    price: '$299/mo',
    users: 'Unlimited users',
    cta: 'Get started',
    included: [
      'Everything in Premium',
      'Crew location map',
      'Emergency muster',
      'API access',
    ],
    locked: [],
  },
]
